import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "@/App.css";
import { Toaster } from "sonner";

import { AuthProvider } from "@/context/AuthContext";
import { PlayerProvider } from "@/context/PlayerContext";
import { AccessCodeProvider } from "@/context/AccessCodeContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import PersistentPlayer from "@/components/PersistentPlayer";

import Home from "@/pages/Home";
import Profile from "@/pages/Profile";
import CategoryPage from "@/pages/CategoryPage";
import PacksPage from "@/pages/PacksPage";
import TrackDetail from "@/pages/TrackDetail";
import PackDetail from "@/pages/PackDetail";
import PoolPage from "@/pages/PoolPage";
import Contact from "@/pages/Contact";
import Admin from "@/pages/Admin";
import AuthCallback from "@/pages/AuthCallback";
import { LoginPromptModal } from "@/components/LoginPrompt";
import { NewsBanner } from "@/components/NewsBanner";
import { PaymentSuccess, PaymentCancel } from "@/pages/Payment";
import { LoadingBar } from "@/components/LoadingBar";
import { api } from "@/lib/api";

function AppRouter() {
  const location = useLocation();
  const [config, setConfig] = useState({});

  useEffect(() => {
    api.get("/config").then((r) => setConfig(r.data)).catch(() => {});
    // Update title
    document.title = "POMATA In Session";
  }, []);

  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }

  return (
    <div className="grain min-h-screen">
      <LoadingBar />
      <Navbar config={config} />
      <NewsBanner />
      <main className="pb-24">
        <Routes>
          <Route path="/" element={<Home config={config} />} />
          <Route path="/perfil" element={<Profile config={config} />} />
          <Route path="/remixes" element={<CategoryPage category="remix" title="Remixes" subtitle="Reinventados" config={config} />} />
          <Route path="/mashups" element={<CategoryPage category="mashup" title="Mashups" subtitle="Dos mundos, un track" config={config} />} />
          <Route path="/pool" element={<PoolPage config={config} />} />
          <Route path="/packs" element={<PacksPage config={config} />} />
          <Route path="/track/:id" element={<TrackDetail config={config} />} />
          <Route path="/pista/:id" element={<TrackDetail config={config} pista />} />
          <Route path="/pack/:id" element={<PackDetail config={config} />} />
          <Route path="/api/share/track/:id" element={<TrackDetail config={config} />} />
          <Route path="/api/share/pista/:id" element={<TrackDetail config={config} pista />} />
          <Route path="/api/share/pack/:id" element={<PackDetail config={config} />} />
          <Route path="/contact" element={<Contact config={config} />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
        </Routes>
      </main>
      <Footer config={config} />
      <PersistentPlayer />
      <LoginPromptModal />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AccessCodeProvider>
          <PlayerProvider>
            <AppRouter />
            <Toaster theme="dark" position="bottom-right" richColors />
          </PlayerProvider>
        </AccessCodeProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
